export default __webpack_public_path__ + "static/media/office1-before1-1024w.ce10f5b4.avif";